/**
 * @prettier
 */
export function transformStringToPercentage(value?: string | null): number {
    if (value === '') return 0;
    return isNaN(value as any) ? 0 : parseFloat(value as any) / 100;
}
